interface IProps {
    opoId: number,
    opoName: string,
    onOpenAssign: (opoId: number) => void
}

const OpoName = ({ opoId, opoName, onOpenAssign }: IProps) => {
    return (
        <div style={{ display: 'flex' }}>
            <div style={{ marginRight: 10 }}>{opoName}</div>
            <div><button className='btn btn-default btn-xs' onClick={() => onOpenAssign(opoId)}>Assign Centers</button></div>
        </div>
    );
}

export default OpoName;